import { GLOBAL_STATE_INDEX_ID as SHARED_GLOBAL_STATE_INDEX_ID } from '@wdx/shared/utils';

export const GLOBAL_STATE_INDEX_ID = SHARED_GLOBAL_STATE_INDEX_ID;
export const FAVOURITES_INDEX_ID = 'FAVOURITES_INDEX_ID';
